import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@mgc/react-components';
import { withRouter } from 'react-router';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import MapPropTypes from '../../MapPropTypes';
import selectors from '../../../selectors';
import UiActions from '../../../actions/ui';
import OrderActions from '../../../actions/order';
import strings from '../../../strings';
import ModalBase from '../Base';
import Summary from '../CheckoutModal/Summary';
import './SubmitOrderSpinner.css';
import CartActions from '../../../actions/cart';

class ExcelValidationModal extends Component {
    static propTypes = {
        // functions
        close: PropTypes.func.isRequired,
        submitOrder: PropTypes.func.isRequired,
        // data
        cart: PropTypes.arrayOf(
            PropTypes.shape({
                item: MapPropTypes.CartItemProps,
                product: MapPropTypes.PricingProps,
            })
        ).isRequired,
        cartTotal: PropTypes.number.isRequired,
        offer: MapPropTypes.OfferProps,
        orderStarted: PropTypes.bool.isRequired,
        orderComplete: PropTypes.bool.isRequired,
        orderIsSuccessful: PropTypes.bool.isRequired,
        orderInProgress: PropTypes.bool.isRequired,
        orderFailed: PropTypes.bool.isRequired,
        isSucessful: PropTypes.bool.isRequired,
        visible: PropTypes.bool.isRequired,
        configurationSheetUploadResponse: PropTypes.object,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            cart: selectors.cart.getCartContents,
            cartTotal: selectors.cart.getTotal,
            offer: selectors.offer.getSelectedOffer,
            orderStarted: selectors.order.excelOrderStarted,
            soldTo: selectors.cart.getSoldTo,
            orderComplete: selectors.order.excelOrderIsComplete,
            orderIsSuccessful: selectors.order.excelOrderIsSuccessful,
            orderInProgress: selectors.order.excelOrderInProgress,
            orderFailed: selectors.order.excelOrderFailed,
            isSucessful: selectors.order.excelOrderIsComplete,
            visible: selectors.ui.getValidationModalVisible,
            configurationSheetUploadResponse:
                selectors.configurations.getconfigurationSheetUploadResponse,
        });

    static mapDispatch = (dispatch, ownProps) => ({
        close: () => dispatch(UiActions.closeValidationModal()),
        submitOrder: (cart) => dispatch(OrderActions.submitExcelOrder(cart)),
        finishOrder: (history) => dispatch(UiActions.finishExcelOrder(history)),
        updateInstructions: (instructions) =>
            dispatch(CartActions.updateCartInstructions(instructions)),
    });

    _handleCloseClick() {
        // action order matter here, since this.props.close() will reset
        // this.props.orderIsSuccessful, making it so that this.props.finishOrder
        // is never called.
        // if (this.props.orderIsSuccessful) {
        // this.props.finishOrder(this.props.history);
        // }
        this.props.finishOrder(this.props.history);
        this.props.close();
    }

    _checkBalanceExceeds() {
        if (this.props.configurationSheetUploadResponse.cart != undefined) {
            let sumOfTotal = 0;
            this.props.configurationSheetUploadResponse.cart.map((item) => {
                sumOfTotal += item.subtotal;
            });
            if (sumOfTotal > this.props.offer.balance) return true;
        }
        return false;
    }

    _handlePrintClick() {
        this.props.finishOrder(this.props.history);
        // if we print() right away, then we get a nice printout of the modal.
        // so we'll wait for the page to re-render before printing.
        // secret bonus: after an order, the user can print a receipt from the /order
        // or /checkout screens *at any time*. we store the last transaction made
        // in our redux store. it's used to fill out the receipt.
        setTimeout(() => window.print(), 250);
    }

    _handleInstructionsUpdate(event) {
        this.props.updateInstructions(event.target.value);
    }

    _closeButtonClass() {
        if (this.props.orderFailed) {
            return 'btn-danger';
        }
        if (this.props.isSucessful) {
            return 'btn-success';
        }
        return 'btn-warning';
    }

    _renderContent() {
        return (
            <Summary
                sheetResponseData={this.props.configurationSheetUploadResponse}
                cart={
                    this.props.configurationSheetUploadResponse.cart
                        ? this.props.configurationSheetUploadResponse.cart
                        : []
                }
                cartTotal={this.props.cartTotal}
                offer={this.props.offer}
                onUpdateInstructions={(e) => this._handleInstructionsUpdate(e)}
                excelUpload={true}
                soldTo={this.props.soldTo}
            />
        );
    }

    _getTitle() {
        if (this.props.orderFailed) {
            return strings.orderFailedTitle;
        }
        if (this.props.orderComplete) {
            return strings.orderSubmitted;
        }
        return strings.confirmOrderQuestion;
    }

    _renderSpinner() {
        if (this.props.orderInProgress) {
            return (
                <div>
                    <div className="spinner-text">
                        Please wait while the order is being submitted...
                    </div>
                    <div className="spinner-container">
                        <div className="loading-spinner"></div>
                    </div>
                </div>
            );
        }
    }

    render() {
        const actionButton = this.props.orderComplete ? (
            <button
                className="btn btn-info"
                onClick={() => this._handlePrintClick()}
                disabled={this.props.orderFailed}
            >
                {strings.printReceipt}
            </button>
        ) : (
            <button
                className="btn btn-success"
                onClick={() =>
                    this.props.submitOrder(
                        this.props.configurationSheetUploadResponse.cart
                    )
                }
                disabled={
                    this.props.orderInProgress || this._checkBalanceExceeds()
                }
            >
                {strings.submitOrder}
            </button>
        );

        return (
            <ModalBase
                modalClassName="checkout-modal"
                modalTitle={this._getTitle()}
                visible={this.props.visible}
                backdrop="static"
                closeModal={() => this._handleCloseClick()}
            >
                {this._renderContent()}
                {this.props.orderFailed ? (
                    <div className="bottomPadding"> {strings.orderFailed} </div>
                ) : (
                    ''
                )}
                {this._checkBalanceExceeds() ? (
                    <div className="text-danger">
                        {strings.InsufficientFunds}
                    </div>
                ) : null}
                <div className="text-right">
                    {this._renderSpinner()}
                    <button
                        className={`btn ${this._closeButtonClass()}`}
                        onClick={() => this._handleCloseClick()}
                        disabled={this.props.orderInProgress}
                    >
                        {this.props.orderComplete
                            ? strings.close
                            : strings.cancel}
                    </button>
                    &nbsp;
                    {actionButton}
                </div>
            </ModalBase>
        );
    }
}

export default withRouter(attach(ExcelValidationModal));



// WEBPACK FOOTER //
// ./app/components/Modals/ExcelValidationModal/index.jsx